// removed by extract-text-webpack-plugin
module.exports = {"loading_modal":"loading_modal--3HI6i","antRotate":"antRotate--IyYp6","antSpinMove":"antSpinMove--1-3ge"};


//////////////////
// WEBPACK FOOTER
// ./src/components/logComponent/loading/loading.css
// module id = 159
// module chunks = 0